<template>
  <el-dialog
    :title="$t('fileLibrary.form.createSubfolder')"
    :visible.sync="dialogVisible"
    width="30%"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-position="top"
      :hide-required-asterisk="true"
    >
      <el-form-item :label="$t('fileLibrary.form.folderName')" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item :label="$t('fileLibrary.form.description')" prop="description">
        <el-input type="textarea" :rows="2" v-model="form.description"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <cus-btn type="cancel" @click="dialogVisible = false"></cus-btn>
      <cus-btn type="save" @click="submit"></cus-btn>
    </span>
  </el-dialog>
</template>

<script>
import { addSubFolder } from "@/api/templateManagement";
export default {
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      parentId: null,
      dialogVisible: false,
      form: {
        name: "",
        description: ""
      },
      rules: {
        name: [
          {
            required: true,
            message:
              this.$t("fileLibrary.form.folderName") +
              " " +
              this.$t("messageCommon.beMandatory"),
            trigger: "blur"
          },
          {
            max: 100,
            message: this.$t("messageCommon.lengthSectionFormatter", [
              "0",
              "100"
            ]),
            trigger: "blur"
          }
        ],
        description: [
          {
            max: 100,
            message: this.$t("messageCommon.lengthSectionFormatter", [
              "0",
              "100"
            ]),
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    show(parentNodeId) {
      this.dialogVisible = true;
      this.parentId = parentNodeId;
      this.form.name = "";
      this.form.description = "";
    },
    submit() {
      this.$refs["form"].validate(valid => {
        if (!valid) {
          return false;
        }
        let params = {
          parentId: this.parentId,
          name: this.form.name,
          description: this.form.description
        };
        addSubFolder(params)
          .then(resp => {
            if (resp.code == 200) {
              let folderObj = {
                id: resp.data.id,
                parentId: resp.data.parentId,
                label: resp.data.name,
                description: resp.data.description,
                createType: 2,
                children: []
              };

              this.$emit("folderAdded", folderObj);

              this.dialogVisible = false;
            }
          })
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>